import { animate, style, transition, trigger } from '@angular/animations';

export const fade = trigger('fade', [
  transition(':enter', [
    style({
      opacity: 0,
    }),
    animate(
      '300ms',
      style({
        opacity: 1,
      })
    ),
  ]),
  transition(':leave', [
    style({
      opacity: 1,
    }),
    animate(
      '300ms',
      style({
        opacity: 0,
      })
    ),
  ]),
]);

export const fadeRight = trigger('fadeRight', [
  transition(':enter', [
    style({
      opacity: 0,
      right: '-100%',
    }),
    animate(
      '300ms',
      style({
        opacity: 1,
        right: 0,
      })
    ),
  ]),
  transition(':leave', [
    style({
      opacity: 1,
      right: 0,
    }),
    animate(
      '300ms',
      style({
        opacity: 0,
        right: '-100%',
      })
    ),
  ]),
]);

export const fadeUp = trigger('fadeUp', [
  transition(':enter', [
    style({
      opacity: 0,
      bottom: '-100%',
    }),
    animate(
      '300ms',
      style({
        opacity: 1,
        bottom: 0,
      })
    ),
  ]),

  transition(':leave', [
    style({
      opacity: 1,
      bottom: 0,
    }),
    animate(
      '300ms',
      style({
        opacity: 0,
        bottom: '-100%',
      })
    ),
  ]),
]);
